<template>
  <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">Aprovar comprovante</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2">Confirmar valor da proposta</v-stepper-step>

    </v-stepper-header>
    <v-stepper-items>
      <!-----------------tela 1------------------------->
      <v-stepper-content step="1" class="pa-0">
      <v-card>
          <v-toolbar color="green" dark>
              <v-toolbar-title>Pagamento</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
              <div>
                <div class="headline">{{proposta.empresa.nome_fantasia}}</div>
                <v-flex xs12 class="text-xs-left pt-2">Meios de pagamento: {{proposta.num_boleto}} </v-flex>
                <v-flex xs12 class="text-xs-left pt-2">Meios de pagamento: {{proposta.chave_pix}} </v-flex>
                <v-flex xs12 class="text-xs-left pt-2">Meios de pagamento: {{proposta.dados_bancarios}} </v-flex>
              </div>
              <v-layout row wrap justify-space-around fill-height>
              </v-layout>
              <v-layout row wrap justify-space-around fill-height>
                  <v-flex xs12 class="text-xs-left pt-2">Status Pagamento: <span class="green--text" v-if="proposta.status_pagamento"> APROVADO </span></v-flex>
                  <v-flex v-if="proposta.comprovante_pagamento" xs12 class="text-xs-left pt-2 "><a target="_blank" :href="proposta.comprovante_pagamento">Acesse o comprovante aqui</a></v-flex>
                  <v-flex v-else xs12 class="text-xs-left pt-2 red--text">Empresa não anexou comprovante ainda</v-flex>
                  <v-flex>
                      <v-checkbox v-if="proposta.desconto"
                      ref="aprovar"
                      v-model="aprovar"
                      :label="`Aprovar`"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn flat color="red" @click="$emit('fechar')">Fechar</v-btn>
                <v-spacer></v-spacer>
              <v-btn v-if="!proposta.status_pagamento" flat color="primary" @click="step = 2">Aprovar Pagamento</v-btn>
            </v-card-actions>
          </v-card>
      </v-stepper-content>
      <!-----------------fim tela 1------------------------->
      <v-stepper-content step="2" class="pa-0">
        <v-card>
        <v-toolbar color="green" dark>
            <v-toolbar-title>Confirmar Valor</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-layout row wrap justify-space-around fill-height>
            </v-layout>
            <v-layout row wrap justify-space-around fill-height v-if="proposta.status_pagamento">
            <h3 class="text-xs-center red--text">ATENÇÃO! Ao confirmar esta operação o valor não será mas alterado</h3>
                <v-flex xs12 class="text-xs-left pt-2">Bônus negociado: {{proposta.desconto}}%  </v-flex>
                <v-flex xs12 class="text-xs-left pt-2">Valor negociado: {{proposta.valor | currency({ fractionCount: 2 })}}</v-flex>
                <h4 class="text-xs-center green--text pt-2 " v-if="!valor_formatado">Empresa terá saldo final para consumo de: R$ {{parseFloat(proposta.valor) + (proposta.valor * this.proposta.desconto / 100)}}</h4>
                <h4 class="text-xs-center green--text pt-2 " v-else>Empresa terá saldo final para consumo de: {{(valor_formatado + (valor_formatado * this.proposta.desconto / 100)) | currency({ fractionCount: 2 })}}</h4>
                <v-flex xs12>
                <v-text-field
                    ref="valor_final"
                    prefix="R$"
                    label="Confirme aqui o valor da proposta"
                    v-money="money"
                    v-model.lazy="valor"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-around fill-height v-else>
            <h4 class="text-xs-center red--text">Para confirmar o valor é necessário aprovar o pagamento da negociação</h4>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="red" @click="cancelar">Cancelar</v-btn>
            <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="finalizarProposta">Finalizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { propostasDao } from '@/api'

import { VMoney } from 'v-money'

export default {
  props: ['proposta'],
  data () {
    return {
      step: 0,
      infoPosto: {
        endereco: {},
        representante: {}
      },
      indoFinalizar: {
        valor_final: null,
        id: null
      },
      selectOpcoes: null,
      cod_barras: null,
      cod_pix: null,
      valor: null,
      valor_formatado: null,
      aprovar: true,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  watch: {
    step (val) {
      if (this.step === 2) {
        this.aprovarPagamento()
      }
    },
    valor (val) {
      if (val !== null || val !== undefined) {
        this.valor_formatado = this.valor.split('.').join('')
        this.valor_formatado = this.valor_formatado.split(',').join('.')
        this.valor_formatado = Number(this.valor_formatado)
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    valorTotal () {
      return this.proposta.qtd_litros * (this.proposta.valor - this.proposta.desconto)
    }
  },
  methods: {
    aprovarPagamento () {
      this.proposta.status_pagamento = this.aprovar
      propostasDao.submeterProposta(this.proposta, this.headers).then(response => {
        if (response.ok) {
          this.step = 2
        } else {
          this.$refs.aprovar.clearableCallback()
        }
      })
    },
    cancelar () {
      this.clearInput()
      this.$emit('fechar')
    },
    finalizarProposta () {
      this.indoFinalizar.id = this.proposta.id
      if (this.valor) {
        this.valor = this.valor.split('.').join('')
        this.valor = this.valor.split(',').join('.')
        this.valor = parseFloat(this.valor)
      }
      this.indoFinalizar.valor_final = this.valor
      propostasDao.confirmarValorProposta(this.indoFinalizar, this.headers).then(response => {
        if (response.ok) {
          this.$emit('fechar')
          this.step = 1
        } else {
          this.cancelar()
        }
      })
    },
    clearInput () {
      this.valor = null
    },
    checkAprovar () {
      if (this.proposta.status_pagamento) {
        this.aprovar = true
      } else {
        this.aprovar = false
      }
    }
  },
  directives: { money: VMoney }
}
</script>
